import React from 'react';

const GameGroupModal = ({ group, onClose, onGameClick, onEditClick }) => {
  const handleGameClick = (e, gameId) => {
    e.preventDefault();
    onGameClick(gameId);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    onEditClick(group.groupId);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <article className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>{group.name}</h2>
          <button aria-label="Close" className="close-button" onClick={onClose}>×</button>
        </header>
        <ul className="game-group-list">
          {group.games.map(game => (
            <li key={game.id}>
              <a href="#" onClick={(e) => handleGameClick(e, game.id)}>
                {game.title} ({game.year_published})
              </a>
            </li>
          ))}
        </ul>
        <footer className="modal-footer">
          {onEditClick && <button onClick={handleEdit} role="button" className="contrast">Edit Group</button>}
        </footer>
      </article>
    </div>
  );
};

export default GameGroupModal;